<template>
  <div id="app" style="height:100%">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view v-if="ifAlive" />
    </keep-alive>
    <router-view v-if="!ifAlive" />
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      ifAlive: false // 是否缓存页面
    }
  },
  watch: {
    '$route': function (val) {
      this.ifAlive = val.meta.keepAlive
    }
  },
  mounted () {
    // ie浏览器面包屑路由跳转无效
    function checkIE () {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue